import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import AppComponent from './AppComponent';
import * as FeaturedActions from '../featured/FeaturedActions';
import * as NotFoundActions from '../notFound/NotFoundActions';
import './Style';


class FeaturedAppContainer extends Component {
    constructor(props) {
        super(props)

        this.state = {
            error: null,
            errorInfo: null
        }
    }

    componentWillMount() {
        document.title = "Featured Listings Page"
    }

    componentDidMount() {
        const { pathname, featuredActions, notFoundActions } = this.props;
        const idMatches = pathname.match(/\/([0-9]+)(\/|$)/);
        const agentId = idMatches && Number.isInteger(+idMatches[1]) ? +idMatches[1] : 0;


        if (agentId) {
            featuredActions.setUrlParams(agentId);
        } else {
            notFoundActions.redirectToNotFound();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.agentId != nextProps.agentId) {
            this.props.featuredActions.getFeatured(nextProps.agentId, this.props.listingPerPage);
        }
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error,
            errorInfo
        }, () => {
            console.error(error, errorInfo);
        })
    }

    render() {

        const { pathname, agentId, getFeaturedFulfilled, getFeaturedError } = this.props;
        const { error } = this.state;

        if (error) {
            return null;
        }

        if ((pathname.indexOf('notFound') === -1
                && (agentId === 0 || !getFeaturedFulfilled)) || getFeaturedError.length) {
            return <div className="loader"></div>;
        }

        return (
            <AppComponent blurValue={this.props.contentBlur} pathname={this.props.pathname}/>
        );
    }
}

FeaturedAppContainer.propTypes = {
    agentId: PropTypes.number.isRequired,
    getFeaturedFulfilled: PropTypes.bool.isRequired,
    getFeaturedError: PropTypes.string.isRequired,
    pathname: PropTypes.string.isRequired
};

const mapStateToProps = (state) => {
    return {
        agentId: state.featured.agentId,
        listingPerPage: state.featured.listingPerPage,
        getFeaturedFulfilled: state.featured.getFeaturedFulfilled,
        getFeaturedError: state.featured.getFeaturedError,
        contentBlur: state.app.contentBlur,
        pathname: state.routing.location.pathname,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        featuredActions: bindActionCreators(FeaturedActions, dispatch),
        notFoundActions: bindActionCreators(NotFoundActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FeaturedAppContainer)
